import { render, staticRenderFns } from "./CreateConsent.vue?vue&type=template&id=951db8e2&"
import script from "./CreateConsent.vue?vue&type=script&lang=js&"
export * from "./CreateConsent.vue?vue&type=script&lang=js&"
import style0 from "./CreateConsent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports